import React, { FC } from 'react';
import { Button } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { BusinessPasswordResetIcon } from '~/img';
import PasswordResetSuccessPanel from '../components/PasswordResetSuccessPanel';
import { login } from '~/routes';
import { useHistory } from 'react-router-dom';

const BusinessRepresentative: FC = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();
  const onClick = () => {
    history.replace(`/${login}`);
  };

  return (
    <PasswordResetSuccessPanel
      title={t('I am a Business Representative')}
      icon={<BusinessPasswordResetIcon />}
    >
      <StyledButton
        type="primary"
        size="large"
        className="PasswordResetSuccess-Button"
        onClick={onClick}
      >
        {t('Log in as a company')}
      </StyledButton>
    </PasswordResetSuccessPanel>
  );
};

const StyledButton = styled(Button)`
  width: 100%;
`;

export default BusinessRepresentative;
